import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const EmojiSadSquareIcon = createIcon({
  displayName: 'EmojiSadSquareIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1'
      d='M8.75 4.75h6.5a4 4 0 0 1 4 4v6.5a4 4 0 0 1-4 4h-6.5a4 4 0 0 1-4-4v-6.5a4 4 0 0 1 4-4Z'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1'
      d='M7.75 15.25S9 12.75 12 12.75s4.25 2.5 4.25 2.5'
    />,
    <circle cx='14' cy='10' r='1' fill='currentColor' />,
    <circle cx='10' cy='10' r='1' fill='currentColor' />
  ],
  defaultProps: defaultProps
})
